import { ref, inject } from 'vue'

interface commentParams {
  pageNo: number,
  pageSize: number,
  objectId: string,
  queryType: number | String,
  objectType: number
}
const getCommentList = async ($http: any, comment_parames: commentParams ) => {
 
  let data = await $http.getAllComment(comment_parames)
  return data
}

export {
  getCommentList
}